import { createI18n } from 'vue-i18n';
import type { I18n, I18nOptions } from 'vue-i18n';

// Import all locale files
import enCommon from './locales/en/common.json';
import enHome from './locales/en/home.json';
import enAbout from './locales/en/about.json';
import enMainScreen from './locales/en/mainscreen.json';
import enActivities from './locales/en/activities.json';
import enEvents from './locales/en/events.json';
import enCredentials from './locales/en/credentials.json';
import enPracticalInfo from './locales/en/practicalInfo.json';
import enHealthInfo from './locales/en/healthInfo.json';
import enCareers from './locales/en/careers.json';
import enTestimonials from './locales/en/testimonials.json';
import enBranches from './locales/en/branches.json';
import enContact from './locales/en/contact.json';
import enRegistration from './locales/en/registration.json';
import enClasses from './locales/en/classes.json';
import enTalent from './locales/en/talent.json';
import enAcademy from './locales/en/academy.json';
import enNerd from './locales/en/nerd.json';

import frCommon from './locales/fr/common.json';
import frHome from './locales/fr/home.json';
import frAbout from './locales/fr/about.json';
import frMainScreen from './locales/fr/mainscreen.json';
import frActivities from './locales/fr/activities.json';
import frEvents from './locales/fr/events.json';
import frCredentials from './locales/fr/credentials.json';
import frPracticalInfo from './locales/fr/practicalInfo.json';
import frHealthInfo from './locales/fr/healthInfo.json';
import frCareers from './locales/fr/careers.json';
import frTestimonials from './locales/fr/testimonials.json';
import frBranches from './locales/fr/branches.json';
import frContact from './locales/fr/contact.json';
import frRegistration from './locales/fr/registration.json';
import frClasses from './locales/fr/classes.json';
import frTalent from './locales/fr/talent.json';
import frAcademy from './locales/fr/academy.json';
import frNerd from './locales/fr/nerd.json';

// Define message schema type (optional but recommended)
type MessageSchema = {
  [key: string]: string | MessageSchema;
};

// Merge locale files with proper namespacing
const messages: Record<string, MessageSchema> = {
  en: {
    ...enCommon,
    ...enHome,
    mainscreen: enMainScreen,
    about: enAbout,
    activities: enActivities,
    events: enEvents,
    credentials: enCredentials,
    practicalInfo: enPracticalInfo,
    healthInfo: enHealthInfo,
    careers: enCareers,
    testimonials: enTestimonials,
    branches: enBranches,
    contact: enContact,
    registration: enRegistration,
    classes: enClasses,
    talent: enTalent,
    academy: enAcademy,
    nerd: enNerd
  },
  fr: {
    ...frCommon,
    ...frHome,
    mainscreen: frMainScreen,
    about: frAbout,
    activities: frActivities,
    events: frEvents,
    credentials: frCredentials,
    practicalInfo: frPracticalInfo,
    healthInfo: frHealthInfo,
    careers: frCareers,
    testimonials: frTestimonials,
    branches: frBranches,
    contact: frContact,
    registration: frRegistration,
    classes: frClasses,
    talent: frTalent,
    academy: frAcademy,
    nerd: frNerd
  }
};

// Get stored language or default to browser language
const storedLanguage = localStorage.getItem('language');
const browserLanguage = navigator.language.split('-')[0]; // 'en-US' -> 'en'
const defaultLanguage = storedLanguage || 
  (browserLanguage === 'fr' ? 'fr' : 'en');

console.log('Initial language:', defaultLanguage); // Add logging

// Create i18n instance
const i18n = createI18n({
  legacy: false, // Use Composition API mode
  locale: defaultLanguage,
  fallbackLocale: 'en',
  messages,
  globalInjection: true, // Make $t available in templates
  missingWarn: false, // Disable warnings for missing translations in production
  fallbackWarn: false // Disable fallback warnings in production
});

export default i18n;